import { render, staticRenderFns } from "./Hospitals.vue?vue&type=template&id=38f97a02&scoped=true"
import script from "./Hospitals.vue?vue&type=script&lang=js"
export * from "./Hospitals.vue?vue&type=script&lang=js"
import style0 from "./Hospitals.vue?vue&type=style&index=0&id=38f97a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f97a02",
  null
  
)

export default component.exports